<template>
  <div class="modal-background">
  </div>
</template>

<script>
export default {
  name: 'ModalBackground',
}
</script>

<style scoped>
.modal-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
}
</style>
